export const schema = {
    "models": {
        "DgtPdProductionOrder": {
            "name": "DgtPdProductionOrder",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "materialType": {
                    "name": "materialType",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "materialCode": {
                    "name": "materialCode",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "materialDescription": {
                    "name": "materialDescription",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "materialMrp": {
                    "name": "materialMrp",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "orderQty": {
                    "name": "orderQty",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": true,
                    "attributes": []
                },
                "materialUnit": {
                    "name": "materialUnit",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "dueDate": {
                    "name": "dueDate",
                    "isArray": false,
                    "type": "AWSDate",
                    "isRequired": true,
                    "attributes": []
                },
                "actualDueDate": {
                    "name": "actualDueDate",
                    "isArray": false,
                    "type": "AWSDate",
                    "isRequired": false,
                    "attributes": []
                },
                "batchNumbers": {
                    "name": "batchNumbers",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                },
                "actualBatchNumbers": {
                    "name": "actualBatchNumbers",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                },
                "trialBatch": {
                    "name": "trialBatch",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "statusFromSap": {
                    "name": "statusFromSap",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "statusFromApp": {
                    "name": "statusFromApp",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "countEditWorkCenter": {
                    "name": "countEditWorkCenter",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "countEditOperation": {
                    "name": "countEditOperation",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "releaseNo": {
                    "name": "releaseNo",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "releasedBy": {
                    "name": "releasedBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "totalYield": {
                    "name": "totalYield",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "division": {
                    "name": "division",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "_ttl": {
                    "name": "_ttl",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "tags": {
                    "name": "tags",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                },
                "createdAt": {
                    "name": "createdAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": true,
                    "attributes": []
                },
                "updatedAt": {
                    "name": "updatedAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": []
                },
                "infoEffBulkDate": {
                    "name": "infoEffBulkDate",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "infoFwt": {
                    "name": "infoFwt",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "infoPallet": {
                    "name": "infoPallet",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "infoRefPkg": {
                    "name": "infoRefPkg",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "infoPacking": {
                    "name": "infoPacking",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "barcodeFgCase": {
                    "name": "barcodeFgCase",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "orderType": {
                    "name": "orderType",
                    "isArray": false,
                    "type": {
                        "enum": "OrderType"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "fgInspectionTypes": {
                    "name": "fgInspectionTypes",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                },
                "infoEaPerPack": {
                    "name": "infoEaPerPack",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "shelfLife": {
                    "name": "shelfLife",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "barcodeEa": {
                    "name": "barcodeEa",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "alternativeText": {
                    "name": "alternativeText",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "shelfLifeMonth": {
                    "name": "shelfLifeMonth",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                }
            },
            "syncable": true,
            "pluralName": "DgtPdProductionOrders",
            "attributes": [
                {
                    "type": "model",
                    "properties": {}
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byDueDate",
                        "fields": [
                            "dueDate"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byStatusFromAppAndDueDate",
                        "queryField": "orderByStatusAndDueDate",
                        "fields": [
                            "statusFromApp",
                            "dueDate"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byDivisionAndStatus",
                        "fields": [
                            "division",
                            "statusFromApp"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byOrderTypeAndReleaseDate",
                        "queryField": "orderByTypeSortByDate",
                        "fields": [
                            "orderType",
                            "createdAt"
                        ]
                    }
                },
                {
                    "type": "auth",
                    "properties": {
                        "rules": [
                            {
                                "allow": "private",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            }
                        ]
                    }
                }
            ]
        },
        "DgtPdOrderOperation": {
            "name": "DgtPdOrderOperation",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "productionOrderId": {
                    "name": "productionOrderId",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "operationNo": {
                    "name": "operationNo",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "workCenterId": {
                    "name": "workCenterId",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "workCenterDescription": {
                    "name": "workCenterDescription",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "actualWorkCenterId": {
                    "name": "actualWorkCenterId",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "actualWorkCenterDescription": {
                    "name": "actualWorkCenterDescription",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "status": {
                    "name": "status",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "active": {
                    "name": "active",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": true,
                    "attributes": []
                },
                "createdBySystem": {
                    "name": "createdBySystem",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "draftedDate": {
                    "name": "draftedDate",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": []
                },
                "draftedBy": {
                    "name": "draftedBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "confirmedDate": {
                    "name": "confirmedDate",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": []
                },
                "confirmedBy": {
                    "name": "confirmedBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "confirmationId": {
                    "name": "confirmationId",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "_ttl": {
                    "name": "_ttl",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "createdAt": {
                    "name": "createdAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": true,
                    "attributes": []
                },
                "updatedAt": {
                    "name": "updatedAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": []
                }
            },
            "syncable": true,
            "pluralName": "DgtPdOrderOperations",
            "attributes": [
                {
                    "type": "model",
                    "properties": {}
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byProductionOrderIdAndOperationNo",
                        "queryField": "operationByOrderIdAndNo",
                        "fields": [
                            "productionOrderId",
                            "operationNo"
                        ]
                    }
                },
                {
                    "type": "auth",
                    "properties": {
                        "rules": [
                            {
                                "allow": "private",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            }
                        ]
                    }
                }
            ]
        },
        "DgtPdOrderOperationLog": {
            "name": "DgtPdOrderOperationLog",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "timeType": {
                    "name": "timeType",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "productionOrderId": {
                    "name": "productionOrderId",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "operationNo": {
                    "name": "operationNo",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "batchNo": {
                    "name": "batchNo",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "postingDate": {
                    "name": "postingDate",
                    "isArray": false,
                    "type": "AWSDate",
                    "isRequired": true,
                    "attributes": []
                },
                "workCenterId": {
                    "name": "workCenterId",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "workCenterDescription": {
                    "name": "workCenterDescription",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "actualWorkCenterId": {
                    "name": "actualWorkCenterId",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "shift": {
                    "name": "shift",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "mch": {
                    "name": "mch",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "startedTime": {
                    "name": "startedTime",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "finishedTime": {
                    "name": "finishedTime",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "totalTime": {
                    "name": "totalTime",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "totalEmployeeRT": {
                    "name": "totalEmployeeRT",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "totalEmployeeOT": {
                    "name": "totalEmployeeOT",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "laborTimeRT": {
                    "name": "laborTimeRT",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "laborTimeOT": {
                    "name": "laborTimeOT",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "yield": {
                    "name": "yield",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "scrap": {
                    "name": "scrap",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "bulkUsedQty": {
                    "name": "bulkUsedQty",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "downtimeCode": {
                    "name": "downtimeCode",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "downtimeDescription": {
                    "name": "downtimeDescription",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "downtimeBaseTime": {
                    "name": "downtimeBaseTime",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "reasonCode": {
                    "name": "reasonCode",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "reasonDescription": {
                    "name": "reasonDescription",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "workingStatus": {
                    "name": "workingStatus",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "pdOrderOperationId": {
                    "name": "pdOrderOperationId",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "_ttl": {
                    "name": "_ttl",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "createdBy": {
                    "name": "createdBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "createdAt": {
                    "name": "createdAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": true,
                    "attributes": []
                },
                "updatedBy": {
                    "name": "updatedBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "updatedAt": {
                    "name": "updatedAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": []
                },
                "split": {
                    "name": "split",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "confirmedDate": {
                    "name": "confirmedDate",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": []
                },
                "confirmedBy": {
                    "name": "confirmedBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "confirmationId": {
                    "name": "confirmationId",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "bulkStatus": {
                    "name": "bulkStatus",
                    "isArray": false,
                    "type": {
                        "enum": "BulkStatus"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "bulkStatusDate": {
                    "name": "bulkStatusDate",
                    "isArray": false,
                    "type": "AWSDate",
                    "isRequired": false,
                    "attributes": []
                },
                "bulkStatusDateTime": {
                    "name": "bulkStatusDateTime",
                    "isArray": false,
                    "type": "AWSTimestamp",
                    "isRequired": false,
                    "attributes": []
                },
                "bulkStatusBy": {
                    "name": "bulkStatusBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "bulkStatusComment": {
                    "name": "bulkStatusComment",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "approveBulkStatusDate": {
                    "name": "approveBulkStatusDate",
                    "isArray": false,
                    "type": "AWSDate",
                    "isRequired": false,
                    "attributes": []
                },
                "approveBulkStatusDateTime": {
                    "name": "approveBulkStatusDateTime",
                    "isArray": false,
                    "type": "AWSTimestamp",
                    "isRequired": false,
                    "attributes": []
                },
                "approveBulkStatusBy": {
                    "name": "approveBulkStatusBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "createdVersion": {
                    "name": "createdVersion",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "updatedVersion": {
                    "name": "updatedVersion",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "materialCode": {
                    "name": "materialCode",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "materialDescription": {
                    "name": "materialDescription",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "orderType": {
                    "name": "orderType",
                    "isArray": false,
                    "type": {
                        "enum": "OrderType"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "orderQty": {
                    "name": "orderQty",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                }
            },
            "syncable": true,
            "pluralName": "DgtPdOrderOperationLogs",
            "attributes": [
                {
                    "type": "model",
                    "properties": {}
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byProductionOrderIDAndOperationNo",
                        "queryField": "operationLogByOrderIdAndNo",
                        "fields": [
                            "productionOrderId",
                            "operationNo"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byBulkStatusDate",
                        "queryField": "orderLogByBulkStatusDate",
                        "fields": [
                            "bulkStatusDate",
                            "bulkStatusDateTime"
                        ]
                    }
                },
                {
                    "type": "auth",
                    "properties": {
                        "rules": [
                            {
                                "allow": "private",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            }
                        ]
                    }
                }
            ]
        },
        "DgtPdOrderReasonCode": {
            "name": "DgtPdOrderReasonCode",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "productionOrderId": {
                    "name": "productionOrderId",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "releaseNo": {
                    "name": "releaseNo",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "materialCode": {
                    "name": "materialCode",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "labOffice": {
                    "name": "labOffice",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "materialDescription": {
                    "name": "materialDescription",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "unit": {
                    "name": "unit",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "reasonCodes": {
                    "name": "reasonCodes",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                },
                "confirmedDate": {
                    "name": "confirmedDate",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": []
                },
                "confirmedBy": {
                    "name": "confirmedBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "confirmStatus": {
                    "name": "confirmStatus",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "_ttl": {
                    "name": "_ttl",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "createdAt": {
                    "name": "createdAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": true,
                    "attributes": []
                },
                "updatedAt": {
                    "name": "updatedAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": []
                }
            },
            "syncable": true,
            "pluralName": "DgtPdOrderReasonCodes",
            "attributes": [
                {
                    "type": "model",
                    "properties": {}
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byProductionOrderId",
                        "queryField": "reasonCodesByOrderId",
                        "fields": [
                            "productionOrderId"
                        ]
                    }
                },
                {
                    "type": "auth",
                    "properties": {
                        "rules": [
                            {
                                "allow": "private",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            }
                        ]
                    }
                }
            ]
        },
        "DgtPdDowntimeCode": {
            "name": "DgtPdDowntimeCode",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "description": {
                    "name": "description",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "active": {
                    "name": "active",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": true,
                    "attributes": []
                },
                "baseTimeForBulk": {
                    "name": "baseTimeForBulk",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                },
                "createdAt": {
                    "name": "createdAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": true,
                    "attributes": []
                },
                "updatedAt": {
                    "name": "updatedAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": []
                }
            },
            "syncable": true,
            "pluralName": "DgtPdDowntimeCodes",
            "attributes": [
                {
                    "type": "model",
                    "properties": {}
                },
                {
                    "type": "auth",
                    "properties": {
                        "rules": [
                            {
                                "allow": "private",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            }
                        ]
                    }
                }
            ]
        },
        "DgtPdWorkCenter": {
            "name": "DgtPdWorkCenter",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "plant": {
                    "name": "plant",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "description": {
                    "name": "description",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "active": {
                    "name": "active",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": true,
                    "attributes": []
                },
                "iotId": {
                    "name": "iotId",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "isRequiredManHour": {
                    "name": "isRequiredManHour",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "isRequiredBatchLotNo": {
                    "name": "isRequiredBatchLotNo",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "isRequiredFGInspect": {
                    "name": "isRequiredFGInspect",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "machineCategory": {
                    "name": "machineCategory",
                    "isArray": false,
                    "type": {
                        "enum": "MachineCategory"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "sapCategoryCode": {
                    "name": "sapCategoryCode",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "sapCategoryName": {
                    "name": "sapCategoryName",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "createdAt": {
                    "name": "createdAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": true,
                    "attributes": []
                },
                "updatedAt": {
                    "name": "updatedAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": []
                }
            },
            "syncable": true,
            "pluralName": "DgtPdWorkCenters",
            "attributes": [
                {
                    "type": "model",
                    "properties": {}
                },
                {
                    "type": "auth",
                    "properties": {
                        "rules": [
                            {
                                "allow": "private",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            }
                        ]
                    }
                }
            ]
        },
        "DgtPdOrderPicklist": {
            "name": "DgtPdOrderPicklist",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "pk": {
                    "name": "pk",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "sk": {
                    "name": "sk",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "materialType": {
                    "name": "materialType",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "materialCode": {
                    "name": "materialCode",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "materialDescription": {
                    "name": "materialDescription",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "materialMrp": {
                    "name": "materialMrp",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "orderQty": {
                    "name": "orderQty",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "materialUnit": {
                    "name": "materialUnit",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "division": {
                    "name": "division",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "kiNo": {
                    "name": "kiNo",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "batchLotNo": {
                    "name": "batchLotNo",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "trialBatch": {
                    "name": "trialBatch",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "status": {
                    "name": "status",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "returnStatus": {
                    "name": "returnStatus",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "releasedDate": {
                    "name": "releasedDate",
                    "isArray": false,
                    "type": "AWSDate",
                    "isRequired": false,
                    "attributes": []
                },
                "releasedBy": {
                    "name": "releasedBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "requestQty": {
                    "name": "requestQty",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "requestedDate": {
                    "name": "requestedDate",
                    "isArray": false,
                    "type": "AWSDate",
                    "isRequired": false,
                    "attributes": []
                },
                "requestedDateTime": {
                    "name": "requestedDateTime",
                    "isArray": false,
                    "type": "AWSTimestamp",
                    "isRequired": false,
                    "attributes": []
                },
                "requestedBy": {
                    "name": "requestedBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "withdrawQty": {
                    "name": "withdrawQty",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "draftedDate": {
                    "name": "draftedDate",
                    "isArray": false,
                    "type": "AWSTimestamp",
                    "isRequired": false,
                    "attributes": []
                },
                "draftedBy": {
                    "name": "draftedBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "approvedDate": {
                    "name": "approvedDate",
                    "isArray": false,
                    "type": "AWSDate",
                    "isRequired": false,
                    "attributes": []
                },
                "approvedDateTime": {
                    "name": "approvedDateTime",
                    "isArray": false,
                    "type": "AWSTimestamp",
                    "isRequired": false,
                    "attributes": []
                },
                "approvedBy": {
                    "name": "approvedBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "checkedDate": {
                    "name": "checkedDate",
                    "isArray": false,
                    "type": "AWSDate",
                    "isRequired": false,
                    "attributes": []
                },
                "checkedDateTime": {
                    "name": "checkedDateTime",
                    "isArray": false,
                    "type": "AWSTimestamp",
                    "isRequired": false,
                    "attributes": []
                },
                "checkedBy": {
                    "name": "checkedBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "qualityCheckedDate": {
                    "name": "qualityCheckedDate",
                    "isArray": false,
                    "type": "AWSDate",
                    "isRequired": false,
                    "attributes": []
                },
                "qualityCheckedDateTime": {
                    "name": "qualityCheckedDateTime",
                    "isArray": false,
                    "type": "AWSTimestamp",
                    "isRequired": false,
                    "attributes": []
                },
                "qualityCheckedBy": {
                    "name": "qualityCheckedBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "usedGoodQty": {
                    "name": "usedGoodQty",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "usedWasteQty": {
                    "name": "usedWasteQty",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "recordedDate": {
                    "name": "recordedDate",
                    "isArray": false,
                    "type": "AWSDate",
                    "isRequired": false,
                    "attributes": []
                },
                "recordedDateTime": {
                    "name": "recordedDateTime",
                    "isArray": false,
                    "type": "AWSTimestamp",
                    "isRequired": false,
                    "attributes": []
                },
                "recordedBy": {
                    "name": "recordedBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "completedDate": {
                    "name": "completedDate",
                    "isArray": false,
                    "type": "AWSDate",
                    "isRequired": false,
                    "attributes": []
                },
                "completedDateTime": {
                    "name": "completedDateTime",
                    "isArray": false,
                    "type": "AWSTimestamp",
                    "isRequired": false,
                    "attributes": []
                },
                "completedBy": {
                    "name": "completedBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "returnGoodQty": {
                    "name": "returnGoodQty",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "returnWasteQty": {
                    "name": "returnWasteQty",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "receivedReturnDateTime": {
                    "name": "receivedReturnDateTime",
                    "isArray": false,
                    "type": "AWSTimestamp",
                    "isRequired": false,
                    "attributes": []
                },
                "receivedReturnBy": {
                    "name": "receivedReturnBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "commentText": {
                    "name": "commentText",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "commentedBy": {
                    "name": "commentedBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "commentActive": {
                    "name": "commentActive",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "extraReturnId": {
                    "name": "extraReturnId",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": false,
                    "attributes": []
                },
                "deprecated": {
                    "name": "deprecated",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "shortageItems": {
                    "name": "shortageItems",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                },
                "externalBom": {
                    "name": "externalBom",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "createdAt": {
                    "name": "createdAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": []
                },
                "infoEffBulkDate": {
                    "name": "infoEffBulkDate",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "infoFwt": {
                    "name": "infoFwt",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "infoPallet": {
                    "name": "infoPallet",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "infoRefPkg": {
                    "name": "infoRefPkg",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "infoPacking": {
                    "name": "infoPacking",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "barcodeFgCase": {
                    "name": "barcodeFgCase",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "barcodePkg": {
                    "name": "barcodePkg",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "orderType": {
                    "name": "orderType",
                    "isArray": false,
                    "type": {
                        "enum": "OrderType"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "receiveDate": {
                    "name": "receiveDate",
                    "isArray": false,
                    "type": "AWSDate",
                    "isRequired": false,
                    "attributes": []
                },
                "barcodeEa": {
                    "name": "barcodeEa",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "alternativeText": {
                    "name": "alternativeText",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                }
            },
            "syncable": true,
            "pluralName": "DgtPdOrderPicklists",
            "attributes": [
                {
                    "type": "model",
                    "properties": {}
                },
                {
                    "type": "key",
                    "properties": {
                        "fields": [
                            "pk",
                            "sk"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byDivisionAndType",
                        "queryField": "picklistByDivisionAndType",
                        "fields": [
                            "division",
                            "materialType"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byReleaseDate",
                        "queryField": "picklistByReleaseDate",
                        "fields": [
                            "releasedDate"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byRequestedDate",
                        "queryField": "picklistByRequestedDate",
                        "fields": [
                            "requestedDate",
                            "requestedDateTime"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byApprovedDate",
                        "queryField": "picklistByApprovedDate",
                        "fields": [
                            "approvedDate",
                            "approvedDateTime"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byCheckedDate",
                        "queryField": "picklistByCheckedDate",
                        "fields": [
                            "checkedDate",
                            "checkedDateTime"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byQualityChecked",
                        "queryField": "picklistByQualityChecked",
                        "fields": [
                            "qualityCheckedDate",
                            "qualityCheckedDateTime"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byRecordedDate",
                        "queryField": "picklistByRecordedDate",
                        "fields": [
                            "recordedDate",
                            "recordedDateTime"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byCompletedDate",
                        "queryField": "picklistByCompletedDate",
                        "fields": [
                            "completedDate",
                            "completedDateTime"
                        ]
                    }
                },
                {
                    "type": "auth",
                    "properties": {
                        "rules": [
                            {
                                "allow": "private",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "get",
                                    "list"
                                ]
                            }
                        ]
                    }
                }
            ]
        },
        "DgtPdOrderPicklistMovement": {
            "name": "DgtPdOrderPicklistMovement",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "orderId": {
                    "name": "orderId",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "sk": {
                    "name": "sk",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "materialCode": {
                    "name": "materialCode",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "materialDescription": {
                    "name": "materialDescription",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "materialUnit": {
                    "name": "materialUnit",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "materialType": {
                    "name": "materialType",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "materialRequestQty": {
                    "name": "materialRequestQty",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "documentYear": {
                    "name": "documentYear",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "documentNo": {
                    "name": "documentNo",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "documentItemNo": {
                    "name": "documentItemNo",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "documentCreatedAt": {
                    "name": "documentCreatedAt",
                    "isArray": false,
                    "type": "AWSTimestamp",
                    "isRequired": true,
                    "attributes": []
                },
                "movementType": {
                    "name": "movementType",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "amount": {
                    "name": "amount",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": true,
                    "attributes": []
                },
                "batchLotNo": {
                    "name": "batchLotNo",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "plant": {
                    "name": "plant",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "postingDate": {
                    "name": "postingDate",
                    "isArray": false,
                    "type": "AWSDate",
                    "isRequired": false,
                    "attributes": []
                },
                "approvedDate": {
                    "name": "approvedDate",
                    "isArray": false,
                    "type": "AWSDate",
                    "isRequired": false,
                    "attributes": []
                },
                "approvedDateTime": {
                    "name": "approvedDateTime",
                    "isArray": false,
                    "type": "AWSTimestamp",
                    "isRequired": false,
                    "attributes": []
                },
                "approvedBy": {
                    "name": "approvedBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "checkedDate": {
                    "name": "checkedDate",
                    "isArray": false,
                    "type": "AWSDate",
                    "isRequired": false,
                    "attributes": []
                },
                "checkedDateTime": {
                    "name": "checkedDateTime",
                    "isArray": false,
                    "type": "AWSTimestamp",
                    "isRequired": false,
                    "attributes": []
                },
                "checkedBy": {
                    "name": "checkedBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "qualityCheckedDate": {
                    "name": "qualityCheckedDate",
                    "isArray": false,
                    "type": "AWSDate",
                    "isRequired": false,
                    "attributes": []
                },
                "qualityCheckedDateTime": {
                    "name": "qualityCheckedDateTime",
                    "isArray": false,
                    "type": "AWSTimestamp",
                    "isRequired": false,
                    "attributes": []
                },
                "qualityCheckedBy": {
                    "name": "qualityCheckedBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "division": {
                    "name": "division",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "usedGoodQty": {
                    "name": "usedGoodQty",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "usedWasteQty": {
                    "name": "usedWasteQty",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "returnGoodQty": {
                    "name": "returnGoodQty",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "returnGoodShrinkQty": {
                    "name": "returnGoodShrinkQty",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "returnWasteQty": {
                    "name": "returnWasteQty",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "recordedDateTime": {
                    "name": "recordedDateTime",
                    "isArray": false,
                    "type": "AWSTimestamp",
                    "isRequired": false,
                    "attributes": []
                },
                "recordedBy": {
                    "name": "recordedBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "returnRefId": {
                    "name": "returnRefId",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "extraRefId": {
                    "name": "extraRefId",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": false,
                    "attributes": []
                },
                "canceledDateTime": {
                    "name": "canceledDateTime",
                    "isArray": false,
                    "type": "AWSTimestamp",
                    "isRequired": false,
                    "attributes": []
                },
                "canceledBy": {
                    "name": "canceledBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "bulkUsedLogs": {
                    "name": "bulkUsedLogs",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                },
                "wasteRecordedDate": {
                    "name": "wasteRecordedDate",
                    "isArray": false,
                    "type": "AWSDate",
                    "isRequired": false,
                    "attributes": []
                },
                "wasteRecordedDateTime": {
                    "name": "wasteRecordedDateTime",
                    "isArray": false,
                    "type": "AWSTimestamp",
                    "isRequired": false,
                    "attributes": []
                },
                "wasteRecordedBy": {
                    "name": "wasteRecordedBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "wasteRecordedStatus": {
                    "name": "wasteRecordedStatus",
                    "isArray": false,
                    "type": {
                        "enum": "WasteRecordStatus"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "approvedWasteReturnDate": {
                    "name": "approvedWasteReturnDate",
                    "isArray": false,
                    "type": "AWSDate",
                    "isRequired": false,
                    "attributes": []
                },
                "approvedWasteReturnDateTime": {
                    "name": "approvedWasteReturnDateTime",
                    "isArray": false,
                    "type": "AWSTimestamp",
                    "isRequired": false,
                    "attributes": []
                },
                "approvedWasteReturnBy": {
                    "name": "approvedWasteReturnBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "otherQty": {
                    "name": "otherQty",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "vendorLotNo": {
                    "name": "vendorLotNo",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "returnReasonCode": {
                    "name": "returnReasonCode",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "returnReasonDescription": {
                    "name": "returnReasonDescription",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                }
            },
            "syncable": true,
            "pluralName": "DgtPdOrderPicklistMovements",
            "attributes": [
                {
                    "type": "model",
                    "properties": {}
                },
                {
                    "type": "key",
                    "properties": {
                        "fields": [
                            "orderId",
                            "sk"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byApprovedDate",
                        "queryField": "movementsByApprovedDate",
                        "fields": [
                            "approvedDate",
                            "approvedDateTime"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byCheckedDate",
                        "queryField": "movementsByCheckedDate",
                        "fields": [
                            "checkedDate",
                            "checkedDateTime"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byQualityChecked",
                        "queryField": "movementsByQualityChecked",
                        "fields": [
                            "qualityCheckedDate",
                            "qualityCheckedDateTime"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byDivision",
                        "queryField": "movementsByDivision",
                        "fields": [
                            "division"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byWasteRecorded",
                        "queryField": "movementsByWasteRecorded",
                        "fields": [
                            "wasteRecordedDate",
                            "wasteRecordedDateTime"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byApprovedWasteReturn",
                        "queryField": "movementsByApprovedWasteReturn",
                        "fields": [
                            "approvedWasteReturnDate",
                            "approvedWasteReturnDateTime"
                        ]
                    }
                },
                {
                    "type": "auth",
                    "properties": {
                        "rules": [
                            {
                                "allow": "private",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "get",
                                    "list"
                                ]
                            }
                        ]
                    }
                }
            ]
        },
        "DgtPdOrderPicklistExtraReturn": {
            "name": "DgtPdOrderPicklistExtraReturn",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "orderId": {
                    "name": "orderId",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "orderInfo": {
                    "name": "orderInfo",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": true,
                    "attributes": []
                },
                "requestMaterialType": {
                    "name": "requestMaterialType",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "kiNo": {
                    "name": "kiNo",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "type": {
                    "name": "type",
                    "isArray": false,
                    "type": {
                        "enum": "ExtraReturnType"
                    },
                    "isRequired": true,
                    "attributes": []
                },
                "status": {
                    "name": "status",
                    "isArray": false,
                    "type": {
                        "enum": "ExtraReturnStatus"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "requestedDate": {
                    "name": "requestedDate",
                    "isArray": false,
                    "type": "AWSDate",
                    "isRequired": false,
                    "attributes": []
                },
                "requestedBy": {
                    "name": "requestedBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "requestedDateTime": {
                    "name": "requestedDateTime",
                    "isArray": false,
                    "type": "AWSTimestamp",
                    "isRequired": false,
                    "attributes": []
                },
                "approvedDate": {
                    "name": "approvedDate",
                    "isArray": false,
                    "type": "AWSDate",
                    "isRequired": false,
                    "attributes": []
                },
                "approvedBy": {
                    "name": "approvedBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "approvedDateTime": {
                    "name": "approvedDateTime",
                    "isArray": false,
                    "type": "AWSTimestamp",
                    "isRequired": false,
                    "attributes": []
                },
                "canceledDate": {
                    "name": "canceledDate",
                    "isArray": false,
                    "type": "AWSDate",
                    "isRequired": false,
                    "attributes": []
                },
                "canceledBy": {
                    "name": "canceledBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "canceledDateTime": {
                    "name": "canceledDateTime",
                    "isArray": false,
                    "type": "AWSTimestamp",
                    "isRequired": false,
                    "attributes": []
                },
                "withdrawedDate": {
                    "name": "withdrawedDate",
                    "isArray": false,
                    "type": "AWSDate",
                    "isRequired": false,
                    "attributes": []
                },
                "withdrawedBy": {
                    "name": "withdrawedBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "withdrawedDateTime": {
                    "name": "withdrawedDateTime",
                    "isArray": false,
                    "type": "AWSTimestamp",
                    "isRequired": false,
                    "attributes": []
                },
                "checkedDate": {
                    "name": "checkedDate",
                    "isArray": false,
                    "type": "AWSDate",
                    "isRequired": false,
                    "attributes": []
                },
                "checkedBy": {
                    "name": "checkedBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "checkedDateTime": {
                    "name": "checkedDateTime",
                    "isArray": false,
                    "type": "AWSTimestamp",
                    "isRequired": false,
                    "attributes": []
                },
                "qualityCheckedDate": {
                    "name": "qualityCheckedDate",
                    "isArray": false,
                    "type": "AWSDate",
                    "isRequired": false,
                    "attributes": []
                },
                "qualityCheckedDateTime": {
                    "name": "qualityCheckedDateTime",
                    "isArray": false,
                    "type": "AWSTimestamp",
                    "isRequired": false,
                    "attributes": []
                },
                "qualityCheckedBy": {
                    "name": "qualityCheckedBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "remark": {
                    "name": "remark",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "items": {
                    "name": "items",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                },
                "extraReturnItems": {
                    "name": "extraReturnItems",
                    "isArray": true,
                    "type": {
                        "model": "DgtPdOrderPicklistExtraReturnItem"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true,
                    "association": {
                        "connectionType": "HAS_MANY",
                        "associatedWith": "extraReturnId"
                    }
                },
                "updatedAt": {
                    "name": "updatedAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": []
                },
                "documentNo": {
                    "name": "documentNo",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "documentYear": {
                    "name": "documentYear",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                }
            },
            "syncable": true,
            "pluralName": "DgtPdOrderPicklistExtraReturns",
            "attributes": [
                {
                    "type": "model",
                    "properties": {}
                },
                {
                    "type": "key",
                    "properties": {
                        "fields": [
                            "id"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byOrderId",
                        "queryField": "extraReturnByOrderId",
                        "fields": [
                            "orderId"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byType",
                        "queryField": "extraReturnByTypeAndStatus",
                        "fields": [
                            "type",
                            "status"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byStatus",
                        "fields": [
                            "status",
                            "updatedAt"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byRequestedDate",
                        "queryField": "extraReturnByRequestedDate",
                        "fields": [
                            "requestedDate",
                            "requestedDateTime"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byApprovedDate",
                        "queryField": "extraReturnByApprovedDate",
                        "fields": [
                            "approvedDate",
                            "approvedDateTime"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byCanceledDate",
                        "queryField": "extraReturnByCanceledDate",
                        "fields": [
                            "canceledDate",
                            "canceledDateTime"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byWithdrawedDate",
                        "queryField": "extraReturnByWithdrawedDate",
                        "fields": [
                            "withdrawedDate",
                            "withdrawedDateTime"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byCheckedDate",
                        "queryField": "extraReturnByCheckedDate",
                        "fields": [
                            "checkedDate",
                            "checkedDateTime"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byQualityChecked",
                        "queryField": "extraReturnByQualityChecked",
                        "fields": [
                            "qualityCheckedDate",
                            "qualityCheckedDateTime"
                        ]
                    }
                },
                {
                    "type": "auth",
                    "properties": {
                        "rules": [
                            {
                                "allow": "private",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "get",
                                    "list"
                                ]
                            }
                        ]
                    }
                }
            ]
        },
        "DgtPdOrderPicklistExtraReturnItem": {
            "name": "DgtPdOrderPicklistExtraReturnItem",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "extraReturnId": {
                    "name": "extraReturnId",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "orderId": {
                    "name": "orderId",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "materialCode": {
                    "name": "materialCode",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "materialDescription": {
                    "name": "materialDescription",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "materialUnit": {
                    "name": "materialUnit",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "batchLotNo": {
                    "name": "batchLotNo",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "qty": {
                    "name": "qty",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "withShQty": {
                    "name": "withShQty",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "wasteQty": {
                    "name": "wasteQty",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "remark": {
                    "name": "remark",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "returnStorageLocation": {
                    "name": "returnStorageLocation",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "returnReasonCode": {
                    "name": "returnReasonCode",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "returnReasonDescription": {
                    "name": "returnReasonDescription",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "active": {
                    "name": "active",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                }
            },
            "syncable": true,
            "pluralName": "DgtPdOrderPicklistExtraReturnItems",
            "attributes": [
                {
                    "type": "model",
                    "properties": {}
                },
                {
                    "type": "key",
                    "properties": {
                        "fields": [
                            "id"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byExtraReturnDoc",
                        "fields": [
                            "extraReturnId"
                        ]
                    }
                },
                {
                    "type": "auth",
                    "properties": {
                        "rules": [
                            {
                                "allow": "private",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "get",
                                    "list"
                                ]
                            }
                        ]
                    }
                }
            ]
        },
        "DgtPdIAMUser": {
            "name": "DgtPdIAMUser",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "username": {
                    "name": "username",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "employeeNo": {
                    "name": "employeeNo",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "email": {
                    "name": "email",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "firstName": {
                    "name": "firstName",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "lastName": {
                    "name": "lastName",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "department": {
                    "name": "department",
                    "isArray": false,
                    "type": {
                        "enum": "Department"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "division": {
                    "name": "division",
                    "isArray": false,
                    "type": {
                        "enum": "Division"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "line": {
                    "name": "line",
                    "isArray": false,
                    "type": {
                        "enum": "ProductionLine"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "roles": {
                    "name": "roles",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                },
                "active": {
                    "name": "active",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "isAdmin": {
                    "name": "isAdmin",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                }
            },
            "syncable": true,
            "pluralName": "DgtPdIAMUsers",
            "attributes": [
                {
                    "type": "model",
                    "properties": {}
                },
                {
                    "type": "key",
                    "properties": {
                        "fields": [
                            "username"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byDepartment",
                        "queryField": "userByDepartment",
                        "fields": [
                            "department"
                        ]
                    }
                },
                {
                    "type": "auth",
                    "properties": {
                        "rules": [
                            {
                                "allow": "private",
                                "operations": [
                                    "get"
                                ]
                            },
                            {
                                "groupClaim": "cognito:groups",
                                "provider": "userPools",
                                "allow": "groups",
                                "groups": [
                                    "Admins"
                                ],
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "get",
                                    "list"
                                ]
                            }
                        ]
                    }
                }
            ]
        },
        "DgtPdOrderInspectionLog": {
            "name": "DgtPdOrderInspectionLog",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "productionOrderId": {
                    "name": "productionOrderId",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "workCenterId": {
                    "name": "workCenterId",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "workCenterDescription": {
                    "name": "workCenterDescription",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "machineId": {
                    "name": "machineId",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "inspectionType": {
                    "name": "inspectionType",
                    "isArray": false,
                    "type": {
                        "enum": "FgInspectionType"
                    },
                    "isRequired": true,
                    "attributes": []
                },
                "inspectionStatus": {
                    "name": "inspectionStatus",
                    "isArray": false,
                    "type": {
                        "enum": "FgInspectionStatus"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "formName": {
                    "name": "formName",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "formUrl": {
                    "name": "formUrl",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "avgFwtByLots": {
                    "name": "avgFwtByLots",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                },
                "submittedDatetime": {
                    "name": "submittedDatetime",
                    "isArray": false,
                    "type": "AWSTimestamp",
                    "isRequired": false,
                    "attributes": []
                },
                "submittedBy": {
                    "name": "submittedBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "approvedDatetime": {
                    "name": "approvedDatetime",
                    "isArray": false,
                    "type": "AWSTimestamp",
                    "isRequired": false,
                    "attributes": []
                },
                "approvedBy": {
                    "name": "approvedBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "createdAt": {
                    "name": "createdAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": true,
                    "attributes": []
                },
                "createdBy": {
                    "name": "createdBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "createdVersion": {
                    "name": "createdVersion",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "updatedAt": {
                    "name": "updatedAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": []
                },
                "updatedBy": {
                    "name": "updatedBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "updatedVersion": {
                    "name": "updatedVersion",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                }
            },
            "syncable": true,
            "pluralName": "DgtPdOrderInspectionLogs",
            "attributes": [
                {
                    "type": "model",
                    "properties": {}
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byProductionOrderAndWc",
                        "queryField": "inspectionLogByOrderAndWc",
                        "fields": [
                            "productionOrderId",
                            "workCenterId"
                        ]
                    }
                },
                {
                    "type": "auth",
                    "properties": {
                        "rules": [
                            {
                                "allow": "private",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "get",
                                    "list"
                                ]
                            }
                        ]
                    }
                }
            ]
        },
        "DgtPdOrderReceipt": {
            "name": "DgtPdOrderReceipt",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "productionOrderId": {
                    "name": "productionOrderId",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "batchLotNo": {
                    "name": "batchLotNo",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "bulkUsage": {
                    "name": "bulkUsage",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "totalAmount": {
                    "name": "totalAmount",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "avgFillingWeight": {
                    "name": "avgFillingWeight",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "retainedIssue": {
                    "name": "retainedIssue",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "microIssue": {
                    "name": "microIssue",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "validateIssue": {
                    "name": "validateIssue",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "shelfLifeIssue": {
                    "name": "shelfLifeIssue",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "testIssue": {
                    "name": "testIssue",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "otherIssue": {
                    "name": "otherIssue",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "remark": {
                    "name": "remark",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "reject": {
                    "name": "reject",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "approvedByPdDate": {
                    "name": "approvedByPdDate",
                    "isArray": false,
                    "type": "AWSDate",
                    "isRequired": false,
                    "attributes": []
                },
                "approvedByPdDatetime": {
                    "name": "approvedByPdDatetime",
                    "isArray": false,
                    "type": "AWSTimestamp",
                    "isRequired": false,
                    "attributes": []
                },
                "approvedByPdBy": {
                    "name": "approvedByPdBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "approvedByQcDate": {
                    "name": "approvedByQcDate",
                    "isArray": false,
                    "type": "AWSDate",
                    "isRequired": false,
                    "attributes": []
                },
                "approvedByQcDatetime": {
                    "name": "approvedByQcDatetime",
                    "isArray": false,
                    "type": "AWSTimestamp",
                    "isRequired": false,
                    "attributes": []
                },
                "approvedByQcBy": {
                    "name": "approvedByQcBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "approvedByWhDate": {
                    "name": "approvedByWhDate",
                    "isArray": false,
                    "type": "AWSDate",
                    "isRequired": false,
                    "attributes": []
                },
                "approvedByWhDatetime": {
                    "name": "approvedByWhDatetime",
                    "isArray": false,
                    "type": "AWSTimestamp",
                    "isRequired": false,
                    "attributes": []
                },
                "approvedByWhMonth": {
                    "name": "approvedByWhMonth",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "approvedByWhBy": {
                    "name": "approvedByWhBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "approvedByFaDate": {
                    "name": "approvedByFaDate",
                    "isArray": false,
                    "type": "AWSDate",
                    "isRequired": false,
                    "attributes": []
                },
                "approvedByFaDatetime": {
                    "name": "approvedByFaDatetime",
                    "isArray": false,
                    "type": "AWSTimestamp",
                    "isRequired": false,
                    "attributes": []
                },
                "approvedByFaBy": {
                    "name": "approvedByFaBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "createdAt": {
                    "name": "createdAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": true,
                    "attributes": []
                },
                "createdBy": {
                    "name": "createdBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "createdVersion": {
                    "name": "createdVersion",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "updatedAt": {
                    "name": "updatedAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": []
                },
                "updatedBy": {
                    "name": "updatedBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "updatedVersion": {
                    "name": "updatedVersion",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "orderMaterialCode": {
                    "name": "orderMaterialCode",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "orderMaterialDesc": {
                    "name": "orderMaterialDesc",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "orderType": {
                    "name": "orderType",
                    "isArray": false,
                    "type": {
                        "enum": "OrderType"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "orderQty": {
                    "name": "orderQty",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "orderTags": {
                    "name": "orderTags",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                },
                "currentApprover": {
                    "name": "currentApprover",
                    "isArray": false,
                    "type": {
                        "enum": "ReceiptApprover"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "isRework": {
                    "name": "isRework",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "reworkedBy": {
                    "name": "reworkedBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "reworkedDatetime": {
                    "name": "reworkedDatetime",
                    "isArray": false,
                    "type": "AWSTimestamp",
                    "isRequired": false,
                    "attributes": []
                },
                "reworkNote": {
                    "name": "reworkNote",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "otherIssueNote": {
                    "name": "otherIssueNote",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "infoEaPerPack": {
                    "name": "infoEaPerPack",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                }
            },
            "syncable": true,
            "pluralName": "DgtPdOrderReceipts",
            "attributes": [
                {
                    "type": "model",
                    "properties": {}
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byProductionOrder",
                        "queryField": "orderReceiptByOrder",
                        "fields": [
                            "productionOrderId",
                            "batchLotNo"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byApprovedByPdDate",
                        "queryField": "receiptByApprovedByPdDate",
                        "fields": [
                            "approvedByPdDate",
                            "approvedByPdDatetime"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byApprovedByQcDate",
                        "queryField": "receiptByApprovedByQcDate",
                        "fields": [
                            "approvedByQcDate",
                            "approvedByQcDatetime"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byApprovedByWhDate",
                        "queryField": "receiptByApprovedByWhDate",
                        "fields": [
                            "approvedByWhDate",
                            "approvedByWhDatetime"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byApprovedByFaDate",
                        "queryField": "receiptByApprovedByFaDate",
                        "fields": [
                            "approvedByFaDate",
                            "approvedByFaDatetime"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "byCurrentApprover",
                        "queryField": "receiptByCurrentApprover",
                        "fields": [
                            "currentApprover",
                            "updatedAt"
                        ]
                    }
                },
                {
                    "type": "auth",
                    "properties": {
                        "rules": [
                            {
                                "allow": "private",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "get",
                                    "list"
                                ]
                            }
                        ]
                    }
                }
            ]
        },
        "DgtPdMovementReason": {
            "name": "DgtPdMovementReason",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "reasonCode": {
                    "name": "reasonCode",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "reasonDesciption": {
                    "name": "reasonDesciption",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "movementType": {
                    "name": "movementType",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "componenType": {
                    "name": "componenType",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "active": {
                    "name": "active",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                }
            },
            "syncable": true,
            "pluralName": "DgtPdMovementReasons",
            "attributes": [
                {
                    "type": "model",
                    "properties": {}
                },
                {
                    "type": "key",
                    "properties": {
                        "fields": [
                            "id"
                        ]
                    }
                },
                {
                    "type": "auth",
                    "properties": {
                        "rules": [
                            {
                                "allow": "private",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            }
                        ]
                    }
                }
            ]
        }
    },
    "enums": {
        "ExtraReturnType": {
            "name": "ExtraReturnType",
            "values": [
                "EXTRA",
                "RETURN"
            ]
        },
        "ExtraReturnStatus": {
            "name": "ExtraReturnStatus",
            "values": [
                "NEW",
                "APPROVED",
                "CANCELED",
                "WITHDRAWED",
                "CHECKED",
                "QA_CHECKED",
                "WAIT_SHORTAGE"
            ]
        },
        "Department": {
            "name": "Department",
            "values": [
                "Production",
                "Warehouse",
                "QC",
                "FA",
                "PM",
                "IT",
                "PL",
                "PO",
                "RD",
                "PK",
                "QS"
            ]
        },
        "Division": {
            "name": "Division",
            "values": [
                "Household",
                "Toiletry"
            ]
        },
        "ProductionLine": {
            "name": "ProductionLine",
            "values": [
                "Mixing",
                "Filling"
            ]
        },
        "BulkStatus": {
            "name": "BulkStatus",
            "values": [
                "PASS",
                "HOLD",
                "REJECT"
            ]
        },
        "OrderType": {
            "name": "OrderType",
            "values": [
                "BULK",
                "FG",
                "CLAIM",
                "REPACK"
            ]
        },
        "Tag": {
            "name": "Tag",
            "values": [
                "PARTIAL",
                "TRIAL_BATCH",
                "PROMOTION"
            ]
        },
        "WasteRecordStatus": {
            "name": "WasteRecordStatus",
            "values": [
                "PD_PENDING",
                "PD_CONFIRMED",
                "QC_APPROVED"
            ]
        },
        "FgInspectionType": {
            "name": "FgInspectionType",
            "values": [
                "PD_FILLING",
                "PD_PACKING",
                "QC_FILLING",
                "QC_PACKING"
            ]
        },
        "FgInspectionStatus": {
            "name": "FgInspectionStatus",
            "values": [
                "TESTING",
                "SUBMITTED",
                "APPROVED"
            ]
        },
        "ReceiptApprover": {
            "name": "ReceiptApprover",
            "values": [
                "PD",
                "QC",
                "WH",
                "FA"
            ]
        },
        "MachineCategory": {
            "name": "MachineCategory",
            "values": [
                "MIXING",
                "STORAGE",
                "SHRINK",
                "FILLING",
                "PLATE",
                "WITHPACK",
                "STICKER",
                "PACKING",
                "FILTER"
            ]
        }
    },
    "nonModels": {
        "FGInspectionForm": {
            "name": "FGInspectionForm",
            "fields": {
                "status": {
                    "name": "status",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "message": {
                    "name": "message",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "path": {
                    "name": "path",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "name": {
                    "name": "name",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "eTag": {
                    "name": "eTag",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "workUrl": {
                    "name": "workUrl",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                }
            }
        },
        "FGInspectionSubmitResponse": {
            "name": "FGInspectionSubmitResponse",
            "fields": {
                "message": {
                    "name": "message",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "avgFwtByLots": {
                    "name": "avgFwtByLots",
                    "isArray": true,
                    "type": {
                        "nonModel": "AvgFwtByLot"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true
                }
            }
        },
        "AvgFwtByLot": {
            "name": "AvgFwtByLot",
            "fields": {
                "BATCH_LOT": {
                    "name": "BATCH_LOT",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "AVG_FWT": {
                    "name": "AVG_FWT",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                }
            }
        },
        "FGInspectionApproveResponse": {
            "name": "FGInspectionApproveResponse",
            "fields": {
                "message": {
                    "name": "message",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                }
            }
        }
    },
    "codegenVersion": "3.4.4",
    "version": "17e558b44a0d6699353040f096898b06"
};